import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Zone from '@wix/da-gruser-shared/pkg/components/Zone';
import GruserContext from '@wix/da-gruser-shared/pkg/context/GruserContext';
import LazyContext from '@wix/da-shared-react/pkg/LazyLoadingImage/LazyContext';
import ExhibitionistBox from '@wix/da-shared-react/pkg/widgets/Exhibitionist/ExhibitionistBox';
import ExhibitionistConfigPopoverLazy from '@wix/da-shared-react/pkg/widgets/Exhibitionist/ExhibitionistConfigPopover/ExhibitionistConfigPopoverLazy';
import defaultRemoveConfirmation from '@wix/da-shared-react/pkg/widgets/defaultRemoveConfirmation';
import FeaturedDeviationBox from '../../UserWidgets.deviation_gruser/FeaturedDeviation/FeaturedDeviationBox';
import FeaturedDeviationConfigPopoverLazy from '../../UserWidgets.deviation_gruser/FeaturedDeviation/FeaturedDeviationConfigPopover/FeaturedDeviationConfigPopoverLazy/FeaturedDeviationConfigPopoverLazy';
import { getProfileGruser } from '../../../selectors/users';

import s from './HomeSection.scss';

export interface Props {}

const HomeSection: React.FC<Props> = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const gruser = useSelector(getProfileGruser);

  const renderTwoColumns = () => (
    <>
      <div className={s['zone-top']}>
        <Zone
          name="topBar"
          mapModuleTypeToWidgetConfig={{
            exhibitionist: {
              viewComponent: ExhibitionistBox,
              configPopoverComponent: ExhibitionistConfigPopoverLazy,
              confirmRemove: defaultRemoveConfirmation({ t, dispatch }),
              widgetCard: {
                minuatureImageSrc:
                  'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-3-carousel-gallery.svg',
                title: t('widgets.exhibitionist.scroller.addButtonHeader'),
                description: t('widgets.exhibitionist.scroller.description'),
              },
            },
          }}
        />
      </div>
      <div className={s['flex-wrap']}>
        <div className={s['zone-column-left']}>
          <Zone
            name="bottomLeft"
            mapModuleTypeToWidgetConfig={{
              exhibitionist: {
                viewComponent: ExhibitionistBox,
                configPopoverComponent: ExhibitionistConfigPopoverLazy,
                confirmRemove: defaultRemoveConfirmation({ t, dispatch }),
                widgetCard: {
                  minuatureImageSrc:
                    'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-6-grid-gallery.svg',
                  title: t('widgets.exhibitionist.gridGallery.addButtonHeader'),
                  description: t(
                    'widgets.exhibitionist.gridGallery.description'
                  ),
                },
              },
              featuredDeviation: {
                viewComponent: FeaturedDeviationBox,
                configPopoverComponent: FeaturedDeviationConfigPopoverLazy,
                confirmRemove: defaultRemoveConfirmation({ t, dispatch }),
                widgetCard: {
                  minuatureImageSrc:
                    'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-10-spotlight.svg',
                  title: t('widgets.featured_deviation.addButtonHeader'),
                  description: t('widgets.featured_deviation.description'),
                },
              },
            }}
          />
        </div>
        <div className={s['zone-column-right']}>
          <Zone name="topRight" mapModuleTypeToWidgetConfig={{}} />
          <Zone
            name="midRight"
            mapModuleTypeToWidgetConfig={{
              featuredPost: {
                viewComponent: FeaturedDeviationBox,
                configPopoverComponent: FeaturedDeviationConfigPopoverLazy,
                confirmRemove: defaultRemoveConfirmation({ t, dispatch }),
                widgetCard: {
                  minuatureImageSrc:
                    'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-7-pinned-post.svg',
                  title: t('widgets.featured_post.addButtonHeader'),
                  description: t('widgets.featured_post.description'),
                },
              },
            }}
          />
        </div>
      </div>
    </>
  );

  return (
    <div className={s['root']}>
      <GruserContext.Provider value={gruser}>
        <LazyContext.Provider value={true}>
          {renderTwoColumns()}
        </LazyContext.Provider>
      </GruserContext.Provider>
    </div>
  );
};
HomeSection.displayName = 'HomeSection';

export default HomeSection;
